<template>
  <div class="background-color:red;">
      <div class="avatar-box" v-if="adv_avatar.length > 0" :style="{width: 3 * size / 75 + 'rem', height: 3 * size / 75 + 'rem'}">
        <van-image round fit="cover" class="gold-head" :src="adv_avatar" :style="{ width: 3 * size / 75 + 'rem', height: 3 * size / 75 + 'rem' }" />
        <van-image round fit="cover" class="avatar-after" :src="head_url?head_url:'@/assets/icon/default_avatar.png'" :style="{ width: 2 * size / 75 + 'rem', height: 2 * size / 75 + 'rem' }"/>
      </div>
      <div v-else class="avatar-box" :style="{width: 3 * size / 75 + 'rem', height: 3 * size / 75 + 'rem'}">
        <van-image round class="avatar-after" :src="head_url?head_url:'@/assets/icon/default_avatar.png'" :style="{ width: 2 * size / 75 + 'rem', height: 2 * size / 75 + 'rem' }" fit="cover"/>
      </div>
  </div>
</template>

<script>
export default {
    name:'avatar',
    props:{
        size:{
            type:Number,
            default: 30
        },
        head_url:{
            type:String,
            default: ''
        },
        adv_avatar: {
            type: String,
            default: ''
        }
    },
    computed:{
        head_src() {
            if(this.head_url && this.head_url.indexOf('https://cdn-xcx-qunsou.weiyoubot.cn') != -1) {
                let src = this.head_url.replace('https://cdn-xcx-qunsou.weiyoubot.cn', 'https://image.xiaoqiandao.com')
                src = src + '?imageMogr2/thumbnail/120x120'
                return src
            }
            return ''
        }
    }
}
</script>

<style lang="scss" scoped>
.avatar-box {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.gold-head {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/Avatar.vue